import { i18n } from "../services/i18nService";

export const globalButtonFocusPath = {
  retry: {
    labelKey: "global.retry",
    focusPath: "retryButtonFocusPath_passThru"
  },
  close: {
    labelKey: "global.close",
    focusPath: "globalModalCloseFocusPath_passThru"
  },
  exit: {
    labelKey: "global.exitApp",
    focusPath: "exitButtonFocusPath_passThru"
  },
  login: {
    labelKey: "pages.login.title",
    focusPath: "globalModalLoginFocusPath_passThru"
  },
  login_signup: {
    labelKey: "global.sections.signup",
    focusPath: "globalModalSectionSignupFocusPath_passThru"
  },
  signup: {
    labelKey: "global.eVoucher.join",
    focusPath: "globalModalSignupFocusPath_passThru"
  },
  startWatching: {
    labelKey: "global.errors.account.invalidStatusEVoucher.button",
    focusPath: "globalModalStartWatchingFocusPath_passThru"
  },
  accept: {
    labelKey: "global.accept",
    focusPath: "globalModalAcceptFocusPath_passThru"
  },
  back: {
    labelKey: "global.back",
    focusPath: "globalModalBackFocusPath_passThru"
  },
  continue: {
    labelKey: "global.continue",
    focusPath: "globalModalContinueFocusPath_passThru"
  },
  cancel: {
    labelKey: "global.cancel",
    focusPath: "globalModalCancelFocusPath_passThru"
  },
  ok: {
    labelKey: "global.ok",
    focusPath: "globalModalCloseFocusPath_passThru"
  },
  no: {
    labelKey: "global.no",
    focusPath: "globalModalNoFocusPath_passThru"
  },
  yes: {
    labelKey: "global.yes",
    focusPath: "globalModalYesFocusPath_passThru"
  },
  delete: {
    labelKey: "global.delete",
    focusPath: "globalModalDeleteFocusPath_passThru"
  },
  finish: {
    labelKey: "global.finish",
    focusPath: "globalModalFinishFocusPath_passThru"
  },
  continueToHome: {
    labelKey: "global.continueToHome",
    focusPath: "globalModalContinueToHomeFocusPath_passThru"
  },
  rent: {
    labelKey: "global.modals.premium.rent",
    focusPath: "globalModalRentFocusPath_passThru"
  },
  purchase: {
    labelKey: "global.modals.premium.buy",
    focusPath: "globalModalPurchaseFocusPath_passThru"
  },
  done: {
    labelKey: "pages.pinSignUp.modalYesCTA",
    focusPath: "pagesModalDoneFocusPath_passThru"
  },
  notNow: {
    labelKey: "pages.pinSignUp.modalNoCTA",
    focusPath: "pagesModalNotNowFocusPath_passThru"
  },
  switch: {
    labelKey: "global.switch",
    focusPath: "globalModalContinueFocusPath_passThru"
  },
};

/**
 * Function to receive the common button name then returns the associated object with button info of label, focusPath
 * List of available global buttons names [retry, close, exit, login]
 *
 * @param {string} buttonName the name of the global button which to retrieve the focus path
 * @param {string} insertedString injected text
 * @returns {object} the global button info object
 * Example:
 * {
 *    label: "Retry",
 *    focusPath: retryButtonFocusPath
 * }
 */
export function getGlobalButtonInfo(buttonName, insertedString = null) {
  return {
    label: i18n.get(globalButtonFocusPath[buttonName].labelKey, insertedString).toUpperCase(),
    focusPath: globalButtonFocusPath[buttonName].focusPath
  };
}

/**
 * Function to receive the common button name then returns the associated focus path as string
 * List of available global buttons names [retry, close, exit, login]
 *
 * @param {string} buttonName the name of the global button which to retrieve the focus path
 * @returns {string} the global button path name
 */
export function getGlobalButtonFocusPath(buttonName) {
  return globalButtonFocusPath[buttonName].focusPath;
}

/**
 * Function to return the config object for the global modal with close button
 *
 * @param {Object} messages Modal title and text message to show on the global modal
 * @param {Function} callback Function to call when press on close button
 * @returns {Object} Config object for showing the global modal
 */
export function getConfigForModalWithCloseButton(messages, callback, packageName) {
  return {
    ...(messages && messages.title && { modalTitle: messages.title }),
    ...(messages && messages.text && { modalText: messages.text }),
    buttons: [
      {
        ...getGlobalButtonInfo(packageName ? "ok" : "close"),
        buttonHandler: callback
      }
    ]
  };
}
